const s = (a) => (e) => !!e.includes(a), l = s("align-items-"), o = s("align-self"), t = s("bg-"), n = s("border-"), c = s("cursor-"), r = s("display-"), C = s("flex-"), h = s("hover-scale-"), i = s("hover-text-color-"), d = s("overflow-"), u = s("padding-"), x = s("rounded-"), g = s("space-"), f = s("text-color-"), p = s("text-size"), v = s("user-select-");
export {
  l as hasAlignItemsClass,
  o as hasAlignSelfClass,
  t as hasBgClass,
  n as hasBorderClass,
  c as hasCursorClass,
  r as hasDisplayClass,
  C as hasFlexClass,
  h as hasHoverScaleClass,
  i as hasHoverTextColorClass,
  d as hasOverflowClass,
  u as hasPaddingClass,
  x as hasRoundedClass,
  g as hasSpaceClass,
  f as hasTextColorClass,
  p as hasTextSizeClass,
  v as hasUserSelectClass
};
//# sourceMappingURL=hasUtilityClass.js.map
